module.exports = "<input *ngIf=\"enabled && (status == 'WAITING' || status == 'ERROR')\" #file type=\"file\" accept=\"image/png, image/gif, image/jpeg\"\n       (change)=\"fileChangeEvent($event)\">\n<p *ngIf=\"enabled && (status == 'WAITING' || status == 'ERROR')\">{{maxSize / 1024 / 1024}}MB 이하의 파일만 업로드 가능합니다.</p>\n<span *ngIf=\"!enabled\">파일 업로드는 ie10부터 지원합니다.</span>\n<span *ngIf=\"status == 'TRANSFER'\">파일 전송중...</span>\n<span *ngIf=\"status == 'FINISH'\">파일 전송완료</span>\n<span *ngIf=\"status == 'ERROR'\">파일 전송실패</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/file-upload/file-upload.component.html
// module id = 1143
// module chunks = 0